"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const react_intl_1 = require("react-intl");
const mui_page_layout_1 = require("@framework/mui-page-layout");
exports.FormButtons = (0, react_1.forwardRef)((props, ref) => {
    const { formButtonProps = {}, visible = true, submit = "submit", showDebug = false, submitRequiresValidForm = true, handleSubmit, } = props;
    const { formState: { isSubmitting, isValid, errors }, } = (0, react_hook_form_1.useFormContext)();
    const disabled = isSubmitting || (submitRequiresValidForm && !isValid);
    if (disabled && showDebug) {
        if (Object.keys(errors).length) {
            console.error("[validation errors]", errors);
        }
    }
    if (!visible) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(mui_page_layout_1.ButtonToolbar, { children: (0, jsx_runtime_1.jsx)(material_1.Button, { onClick: handleSubmit, ref: ref, variant: "contained", color: "primary", disabled: disabled, "data-testid": "FormSubmitButton", ...formButtonProps, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `form.buttons.${submit}` }) }) }));
});
//# sourceMappingURL=index.js.map